import axios from 'Axios'
import qs from 'qs'
import store from '@/store/index'
import {Message} from "element-ui"
import router from "@/router"
import { apiUrl } from '@/assets/js/apiConfig'
var timeOut = 0;
// 设置默认请求头
axios.defaults.headers = {
  	"Content-Type": "application/x-www-form-urlencoded"
}
//axios.defaults.withCredentials = true
//设置axios请求超时时间
axios.defaults.timeout = 2*60*1000;
//配置发送请求前的拦截器 可以设置token信息
axios.interceptors.request.use(config => {
	if(!config.form) { config.form = 'haozhang' }
	if(config.json){ config.headers['Content-Type'] = 'application/json;charset=UTF-8'}
	if(config.upload){config.headers['Content-Type'] = 'multipart/form-data'}
  if(config.form == "upload") {
    config.baseURL = "";
    config.headers['Content-Type'] = "multipart/form-data";
  }else {
    config.baseURL = apiUrl[config.form]
  }
	//loading开始
	store.commit('LOADSTATECHANGE', true);
	if(config.method == 'post'){
		//添加Token
    if(config.form != "upload") {
	  if(config.json){
		config.headers['token'] =  sessionStorage.getItem('token') || config.data.token
		config.headers['cid'] =  sessionStorage.getItem('cid') || config.data.cid
	  }else if(config.upload){
      config.headers['token'] =  sessionStorage.getItem('token') || config.data.token
      config.headers['cid'] =  sessionStorage.getItem('cid') || config.data.cid
	  }else{
		config.data.token = sessionStorage.getItem('token') || config.data.token;
		config.data.cid = sessionStorage.getItem('cid') || config.data.cid;
		config.data = qs.stringify(config.data,{arrayFormat: 'indices', allowDots: true});
	  }
    }
	}
	return config;
}, error => {
	//出错，也要loading结束
	store.commit('LOADSTATECHANGE', false);
	return Promise.reject(error);
});
// 配置响应拦截器
axios.interceptors.response.use(res => {
	//loading结束
	//store.commit('LOADSTATECHANGE', false);
	//这里面写所需要的代码
	if(res.data.code && res.data.code != '1'){
		if(res.data.code == '3'){
			const cont = store.state.loadstatus.requestHttp;
			if(cont) {
				store.commit('REQUEXTHTTP_ONE',false);
				Message.error(res.data.msg);
			}
			//当token失效是跳转到登陆页面
			sessionStorage.clear();
			store.commit('CLEARROUTER');
			store.commit('CLEAR_SUBJEXT_STATE');
			store.commit('DEL_ALL_VISITED_VIEWS');
			store.commit('DEL_ALL_CACHED_VIEWS');
			store.commit('CLEAR_YEARPERIODS_INFO');
			router.push({
			    path: "/login"
			});
		}else if(res.data.code == '7') {
			// 账套过期
			Message.error(res.data.msg)
		}else if(res.data.code == '8') {
			const cont = store.state.loadstatus.requestHttp;
			if(cont) {
				store.commit('REQUEXTHTTP_ONE',false);
				Message.error(res.data.msg);
			}

			sessionStorage.clear();
			store.commit('CLEARROUTER');
			store.commit('CLEAR_SUBJEXT_STATE');
			store.commit('DEL_ALL_VISITED_VIEWS');
			store.commit('DEL_ALL_CACHED_VIEWS');
			store.commit('CLEAR_YEARPERIODS_INFO');
			router.push({
			    path: "/login"
			});

		}else if(res.data.code == '200'||res.data.code == '502'||res.data.code=='92'){
			// do something
	    }else if(res.data.code == '99'){
			Message.warning(res.data.msg);
	    }else{
	      let now = new Date().getTime();
	      if(now-timeOut>1000){
	        Message.error(res.data.msg);
	        timeOut =now;
	      }

		};
		//return false;
	}else{
		store.commit('REQUEXTHTTP_ONE',true);
	};
	return Promise.resolve(res);
}, error => {
	// if (!navigator.onLine) {
	// 	let now = new Date().getTime();
	// 	if( now-timeOut>1000){
	// 		Message.error("连接到服务器失败,请检查网络！");
	// 		timeOut =now;
	// 	}
	// 	 return
	// }
	store.commit('LOADSTATECHANGE', false);
	if (error && error.response) {
	  switch (error.response.status) {
	    case 400:
	      error.message = "错误请求"
	      break
	    case 401:
	      error.message = "未授权，请联系管理员"
	      break
	    case 403:
	      error.message = "拒绝访问"
	      break
	    case 404:
	      error.message = "请求错误,未找到该资源"
	      break
	    case 405:
	      error.message = "请求方法未允许"
	      break
	    case 408:
	      error.message = "请求超时"
	      break
	    case 500:
	      error.message = "服务器端出错"
	      break
	    case 501:
	      error.message = "网络未实现"
	      break
	    case 502:
	      error.message = "网络错误"
	      break
	    case 503:
	      error.message = "服务不可用"
	      break
	    case 504:
	      error.message = "网络超时"
	      break
	    case 505:
	      error.message = "http版本不支持该请求"
	      break;
	    default:
	      error.message = `连接错误${error.response.status}`
	  }
	} else {
    if (error.message.indexOf("timeout") !== -1) {
      error.message = "请求超时！请您稍后重试"
    }
    if (error.message.indexOf("Network Error") !== -1) {
      error.message = "连接到服务器失败,请检查网络！"
    }
	}

	let now = new Date().getTime();
  if(now - timeOut > 1000){
    Message.error(error.message);
    timeOut = now;
  }
	return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/assets/utils/https.js